import { Box, Typography, useMediaQuery } from "@mui/material";
import { theme } from "../../../utils/theme/godzilla_light";
import GradientImg from '../../../assets/images/svgs/gradiant.svg';
import GradientMobileImg from '../../../assets/images/svgs/gradient_mobile.svg';

const styles = {
    gradientCard: {
        background: '#fff',
        ...theme.components.shadowCard,
        mt: "12px",
        display: "flex",
        position: "relative",
        p: "40px",
        overflow: "hidden"
    },
    contentStyle: {
        ...theme.typography.poppinsBodyRegular,
        fontWeight: 500,
        fontSize: "14.38px",
        fontStyle: "italic",
        zIndex: 2,
        position: "relative",
        justifyContent: "center"
    },
};

interface IGradientCardProps {
    content?: string | JSX.Element;
    cardSx?: any;
    contentSx?: any;
}

const GradientCard = (props: IGradientCardProps) => {
    const { content, cardSx, contentSx } = props;
    const isMobileX = useMediaQuery(theme.breakpoints.down(700))
    
    return (
        <Box sx={{ ...styles.gradientCard, ...cardSx }}>
            <Typography sx={{ ...styles.contentStyle, ...contentSx }}>
                {content}
            </Typography>
            <img src={isMobileX ? GradientMobileImg : GradientImg} alt="gradient-decoration" style={{
                position: "absolute",
                bottom: 0,
                right: 0,
                height: "100%",
                zIndex: 1,
                pointerEvents: "none",
                userSelect: "none",
            } as React.CSSProperties} />
        </Box>
    );
};

export default GradientCard;
